export interface ILogger {
    debug(message: string, ...data: any[]): void;
    warn(message: string, ...data: any[]): void;
    error(message: string, ...data: any[]): void;
    info(message: string, ...data: any[]): void;
}

export class Log implements ILogger {
    
    public debug(message: string, ...data: any[]): void {
        this.logMessage('DEBUG', message, data);
    }

    public warn(message: string, ...data: any[]): void {
        this.logMessage('WARN', message, data);
    }

    public error(message: string, ...data: any[]): void {
        this.logMessage('ERROR', message, data);
    }

    public info(message: string, ...data: any[]): void {
        this.logMessage('INFO', message, data);
    }


    private logMessage(level: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR', message: string, additionalInfo: any[]) {
        switch (level) {
            case 'DEBUG':
                console.debug(message, JSON.stringify(additionalInfo));
                break;

            case 'INFO':
                console.info(message, JSON.stringify(additionalInfo));
                break;

            case 'WARN':
                console.warn(message, JSON.stringify(additionalInfo));
                break;

            case 'ERROR':
                console.error(message, JSON.stringify(additionalInfo));
                break;

            default:
                throw new Error('Illegal Log level');
        }


    }
}